import dynamic from 'next/dynamic';

/**
 * We disable SSR on this component to prevent mismatches between the server and client.
 * The server would render the signed in user their username or (formatted) wallet address.
 * However, the client would render 'You' since the user is logged in.
 */
export const ClientWalletLink = dynamic(() => import('@sphere/ui').then(mod => mod.WalletLink), {
  ssr: false,
});
